import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { getCivilitiesQuery } from "rsl-api-106/lib/queries";
import { Query, QueryGetCivilitiesArgs } from "rsl-api-106/lib/types";

import { useQuery } from "@apollo/client";
import { useSession } from "@hooks";

import { SelectOptionType } from "../../../../types";

type RadioCivilityProps = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string | undefined;
  required?: boolean;
};

const RadioCivility: React.FC<RadioCivilityProps> = ({
  value,
  onChange,
  required,
}) => {
  const { sessionId } = useSession();
  const { data, error, loading } = useQuery<Query, QueryGetCivilitiesArgs>(
    getCivilitiesQuery(),
    {
      variables: { session: { name: sessionId!! } },
    }
  );
  const [civilitiesOptions, setCivilitiesOptions] = useState<
    SelectOptionType[]
  >([]);

  useEffect(() => {
    if (data && data.getCivilities?.civilitiyList) {
      const options: SelectOptionType[] =
        data.getCivilities.civilitiyList?.map((x) => {
          return {
            value: x?.code as string,
            label: x?.label as string,
          };
        }) ?? [];
      setCivilitiesOptions(options);
    }
  }, [data]);

  return (
    <>
      <div className="tw-flex tw-flex-wrap tw-gap-4 tw-items-center">
        {civilitiesOptions
          .filter(
            (x) =>
              x.value.toLowerCase() === "m" ||
              x.value.toLowerCase() === "mm" ||
              x.value.toLowerCase() === "cie"
          )
          .map((x, i) => {
            return (
              <div key={`civility_${x.value}_${i}`}>
                <input
                  required={required}
                  type="radio"
                  name="radio_civility"
                  checked={x.value === value}
                  value={x.value}
                  id={`rc_${x.value}`}
                  onChange={onChange}
                />
                <label
                  className={clsx(
                    "tw-ml-1",
                    x.value !== value && "tw-text-[#a3a3a3]"
                  )}
                  htmlFor={`rc_${x.value}`}
                >
                  {x.label}
                </label>
              </div>
            );
          })}
      </div>
    </>
  );
};

RadioCivility.propTypes = {
  //
};

export default RadioCivility;
